import axios from 'axios';

export const staticApi = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
}); 